<div class="flex-horizontal flex-center">
  <oui-tag
    *ngIf="config.tagType === 'status'"
    type="status"
    [status]="statusValue"
    [size]="size"
    [declination]="config.declination">
    {{ config.label }}
  </oui-tag>
  <oui-tag
    *ngIf="config.tagType === 'brand'"
    type="brand"
    [brand]="brandValue"
    [size]="size"
    [declination]="config.declination">
    {{ config.label }}
  </oui-tag>
</div>
